
import React from 'react';
import { ResearchTypeSelectorProps } from './types/research-types';
import { RESEARCH_TYPES } from '@/types/research-types';
import ResearchTypeItem from './components/ResearchTypeItem';

const ResearchTypeSelector: React.FC<ResearchTypeSelectorProps> = React.memo(({
  selectedType,
  onTypeChange,
  filters,
  onFiltersChange
}) => {
  const handleTypeSelect = (typeId: string) => {
    // Toggle functionality: if clicking the already selected type, deselect it
    if (selectedType === typeId) {
      // Deselect the current type by setting it to null
      onTypeChange(null);
    } else {
      // Select the new type
      onTypeChange(typeId);
    }
  };

  return (
    <div className="space-y-3">
      <div className="grid grid-cols-1 gap-3">
        {RESEARCH_TYPES.map((type) => {
          const isSelected = selectedType === type.id;
          
          return (
            <ResearchTypeItem
              key={type.id}
              type={type}
              isSelected={isSelected}
              isExpanded={false} // Never expanded now
              onSelect={handleTypeSelect}
            />
          );
        })}
      </div>
    </div>
  );
});

ResearchTypeSelector.displayName = 'ResearchTypeSelector';

export default ResearchTypeSelector;
